export type ProtocolId = 'NETWORK_BOOST' | 'MARKET_SHIELD' | 'LIQUIDITY_MINING' | 'ORACLE_ARRAY' | 'EXECUTION_LAYER' | 'RESERVE_MINT'

export interface ProtocolDefinition {
  readonly id: ProtocolId
  readonly name: string
  readonly description: string
  readonly stat: string
  readonly color: string
  readonly glyph: string
}

export const PROTOCOLS: Record<ProtocolId, ProtocolDefinition> = {
  NETWORK_BOOST: { id: 'NETWORK_BOOST', name: 'NETWORK BOOST', description: 'Optimizes every defense node.', stat: '+15% ALL ATTACK SPEED', color: '#35d8ea', glyph: '⌬' },
  MARKET_SHIELD: { id: 'MARKET_SHIELD', name: 'MARKET SHIELD', description: 'Reinforces the Genesis Core.', stat: '+15 CORE INTEGRITY', color: '#65a9ff', glyph: '◇' },
  LIQUIDITY_MINING: { id: 'LIQUIDITY_MINING', name: 'LIQUIDITY MINING', description: 'Extracts more value from threats.', stat: '+25% KILL REWARDS', color: '#9b72ff', glyph: '◉' },
  ORACLE_ARRAY: { id: 'ORACLE_ARRAY', name: 'ORACLE ARRAY', description: 'Extends predictive targeting telemetry.', stat: '+12% ALL TOWER RANGE', color: '#47e6ff', glyph: '⌖' },
  EXECUTION_LAYER: { id: 'EXECUTION_LAYER', name: 'EXECUTION LAYER', description: 'Optimizes payload settlement at impact.', stat: '+12% ALL TOWER DAMAGE', color: '#ff7fcf', glyph: '✦' },
  RESERVE_MINT: { id: 'RESERVE_MINT', name: 'RESERVE MINT', description: 'Issues immediate tactical liquidity.', stat: '+750 USDT IMMEDIATELY', color: '#ffd377', glyph: '₮' },
}

export const PROTOCOL_IDS = Object.keys(PROTOCOLS) as ProtocolId[]
